export default __webpack_public_path__ + "static/1-home-page-9103a7f1bb5ab151f77532a8d03ef573.jpg";